import React from 'react';
import PropTypes from 'prop-types';

const UPHidden = ({ children, hidden }) => (
  <div style={hidden ? { display: 'none' } : undefined}>{children}</div>
);

UPHidden.propTypes = {
  children: PropTypes.node,
  hidden: PropTypes.bool,
};

UPHidden.displayName = 'UPHidden';

export default UPHidden;
